/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs */

const en_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift a single word back to the end of the previous Event`)
};

const fr_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer un mot vers la fin de l'evenement precedent`)
};

const de_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschiebe ein einzelnes Wort an das Ende des vorherigen Ereignisses.`)
};

const it_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta una singola parola alla fine dell'evento precedente`)
};

const ru_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвинуть на одно слово назад, в конец предыдущего события.`)
};

const es_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar una sola palabra al final del evento anterior`)
};

const zh_cn2_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将一个词移回上一个事件的末尾`)
};

const ja_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1つの単語を前のイベントの末尾に戻します`)
};

const hi_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक शब्द को पिछले इवेंट के अंत में ले जाएं।`)
};

const pt_pt2_shortcut_keys_desc_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desloque uma única palavra para o final do evento anterior.`)
};

/**
* | output |
* | --- |
* | "Shift a single word back to the end of the previous Event" |
*
* @param {Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_word_to_previous_event = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_move_word_to_previous_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_move_word_to_previous_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_move_word_to_previous_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_move_word_to_previous_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_move_word_to_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_move_word_to_previous_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_move_word_to_previous_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_move_word_to_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_move_word_to_previous_event(inputs)
	return en_shortcut_keys_desc_move_word_to_previous_event(inputs)
});